import { Component, Input } from '@angular/core';
import { ConfigProvider } from '../../providers/config/config';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { NavController, NavParams, ModalController, Events ,PopoverController} from 'ionic-angular';
import { ProductDetailPage } from '../../pages/product-detail/product-detail';
import { LoginPage } from '../../pages/login/login';
import { NewPricePage } from '../../pages/pricing/pricing';
import { HomePage } from '../../pages/home/home';
import { Http } from '@angular/http';

@Component({
  selector: 'product',
  templateUrl: 'product.html'
})
export class ProductComponent {

  @Input('data') p;//product data
  @Input('type') type;
	editPricing = '';
	newPrice = '';
	formData = { newPrice: '', product_id: '',customer_id:'' };
	updateinProgress = false;


  // @Output() someEvent = new EventEmitter();
  constructor(
	  public http: Http,
    public config: ConfigProvider,
    public shared: SharedDataProvider,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
		public popoverCtrl: PopoverController,
    public events: Events

  ) {


  }

	updatePricing(products_id,editPricing,product)
	{
		this.updateinProgress = true;
		//console.log("Update Pricing %s %s %s %s",products_id,editPricing,this.newPrice,this.shared.customerData.customers_id );
		this.formData.newPrice = this.newPrice;

		this.formData.product_id = products_id;
		this.formData.customer_id = this.shared.customerData.customers_id;
		this.http.post(this.config.url + 'updatePricing', this.formData).map(res => res.json()).subscribe(data => {
		//	this.loading.hide();
		product.arSpecialPrice = this.newPrice;
    product.arSpecial = 1;
		//this.events.publish('products:pricechange','Data');
		this.editPricing='';
			if (data.success == 1) {
        this.updateinProgress = false;

      }
      if (data.success == 0) {
        this.updateinProgress = false;
      }
    });


	}
  pDiscount() {
    var rtn = "";
    var p1 = parseInt(this.p.products_price);
    var p2 = parseInt(this.p.discount_price);
    if (p1 == 0 || p2 == null || p2 == undefined || p2 == 0) { rtn = ""; }
    var result = Math.abs((p1 - p2) / p1 * 100);
    result = parseInt(result.toString());
    if (result == 0) { rtn = "" }
    rtn = result + '%';
    return rtn;
  }

  showProductDetail() {
    this.navCtrl.push(ProductDetailPage, { data: this.p });
    if (this.type != 'recent') this.shared.addToRecent(this.p);
  }

  checkProductNew() {
    var pDate = new Date(this.p.products_date_added);
    var date = pDate.getTime() + this.config.newProductDuration * 86400000;
    var todayDate = new Date().getTime();
    if (date > todayDate)
      return true;
    else
      return false
  }

  addToCart() { this.shared.addToCart(this.p, []); }

  isInCart() {
    var found = false;

    for (let value of this.shared.cartProducts) {
      if (value.products_id == this.p.products_id) { found = true; }
    }

    if (found == true) return true;
    else return false;
  }
  removeRecent() {
    this.shared.removeRecent(this.p);
  }

	clickSetPrice(product){
		console.log("Set Price:",product);

		if(this.editPricing == '')
		{
		this.editPricing = product.products_id;
	}
	else{
		this.editPricing = '';
	}

	}

	refreshScreen(){
		console.log("Here");
 		//this.events.publish('products:pricechange','Data');
	}

  clickWishList() {

    if (this.shared.customerData.customers_id == null || this.shared.customerData.customers_id == undefined) {
      let modal = this.modalCtrl.create(LoginPage);
      modal.present();
    }
    else {
      if (this.p.isLiked == '0') { this.addWishList(); }
      else this.removeWishList();
    }
  }
  addWishList() {
    this.shared.addWishList(this.p);
  }
  removeWishList() {
    this.shared.removeWishList(this.p);
  }


  ngOnChanges() {

  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/components/product/product.ts